// extracted by mini-css-extract-plugin
export default {"label":"WarehouseTypeTag_label__d2JSU","label__icon":"WarehouseTypeTag_label__icon__dJ7Ot"};